import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta, QueryReturnValue } from "@reduxjs/toolkit/query/react";
import { identityClient } from "@/auth/identity";


export const baseQuery = fetchBaseQuery({
  credentials: "include",
  baseUrl: "/api",
  fetchFn: async (input, init) => {
    if (identityClient.getSnapshot().status === "signed_out") return fetch(input, init);
    const token = await identityClient.getToken().catch(() => null);
    return token ? identityClient.authFetch(input, init) : fetch(input, init);
  },
});

function isRateLimited(error: FetchBaseQueryError): boolean {
  return (
    error.status === 429 ||
    (error.status === "PARSING_ERROR" && error.originalStatus === 429)
  );
}

const resultCheck = (
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>
) => {
  if (!result.error) return;

  if (result.error.status === 401) {
    window.location.href = "/unauthorized";
  }

  if (result.error.status === 402 && window.location.pathname !== "/subscription") {
    window.location.href = "/subscription";
  }

  if (isRateLimited(result.error)) {
    console.log('rate limited:',result.error);
    window.location.href = "/rate-limited";
  }

  if (result.error.status === 409) {
    if (window.location.pathname !== "/conflict") {
      window.location.href = "/conflict";
    }
  }
};




export const normalBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  return result;
};

export const baseQueryWithAutoRefresh: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  resultCheck(result);
  return result;
};
